import { PdfUploadPage } from './PdfUploadPage';
export default PdfUploadPage;
